import { Controller } from "@hotwired/stimulus"

// Controla el sidebar del admin — toggleable en cualquier breakpoint.
// Estado persiste en localStorage ("admin-sidebar-open": "true"/"false").
// En mobile muestra overlay al abrir. En desktop solo desliza sin overlay.
export default class extends Controller {
  static targets = ["sidebar", "overlay", "main"]

  connect() {
    const saved = localStorage.getItem("admin-sidebar-open")
    const isMobile = window.innerWidth < 1024

    // Primera visita: abierto en desktop, cerrado en mobile.
    // Siempre ejecutar show o hide para sincronizar sidebar + margen del main.
    const shouldOpen = saved === "true" || (saved === null && !isMobile)
    if (shouldOpen) {
      this.#show()
    } else {
      this.#hide({ save: false })
    }
  }

  toggle() {
    this.#isOpen() ? this.#hide({ save: true }) : this.#show()
  }

  // Para el click en el overlay (mobile)
  close() {
    this.#hide({ save: true })
  }

  #isOpen() {
    return !this.sidebarTarget.classList.contains("-translate-x-full")
  }

  #show() {
    this.sidebarTarget.classList.remove("-translate-x-full")
    this.mainTarget.classList.add("ml-64")

    if (window.innerWidth < 1024) {
      this.overlayTarget.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")
    }

    localStorage.setItem("admin-sidebar-open", "true")
  }

  #hide({ save }) {
    this.sidebarTarget.classList.add("-translate-x-full")
    this.mainTarget.classList.remove("ml-64")
    this.overlayTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")

    if (save) localStorage.setItem("admin-sidebar-open", "false")
  }
}
